import { render, staticRenderFns } from "./SalesQuestions.vue?vue&type=template&id=3a7a70f6&scoped=true"
import script from "./SalesQuestions.vue?vue&type=script&lang=js"
export * from "./SalesQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a70f6",
  null
  
)

export default component.exports